import React from 'react'
import { useSearchParams } from 'react-router-dom'

const SearchUserInput = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const search = searchParams.get('search') || ''

  const handleSearchChange = e => {
    const newValue = e.target.value
    const updatedParams = new URLSearchParams(searchParams.toString())
    updatedParams.set('search', newValue)
    updatedParams.set('page', 1)
    setSearchParams(updatedParams)
  }

  return (
    <input
      type="text"
      placeholder="Buscar usuario..."
      value={search}
      onChange={handleSearchChange}
      className="custom-input-list-user"
    />
  )
}

export default SearchUserInput
